import { Component, Input } from '@angular/core';
import { BreadCrumb } from '../../models/breadCrumb';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {

  @Input('linkMap') linkMap: BreadCrumb[] = [];

  constructor(
    public languageService:LanguageService){}
}
